import { render, staticRenderFns } from "./DataShengHua.vue?vue&type=template&id=4315f979&"
import script from "./DataShengHua.vue?vue&type=script&lang=js&"
export * from "./DataShengHua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports